import { AlkLogger } from '../alk-logger';
import { memoize } from '../../utils';
export const fetchJsonFile = async (path) => {
    return (await fetch(path).catch(err => {
        AlkLogger.error(err);
        throw err;
    }))
        .json().catch(err => {
        AlkLogger.error(err);
        throw err;
    });
};
export const fetchJson = memoize(fetchJsonFile);
